import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  AbstractEnumTag,
  ENUM_TAG_IMPORTS,
  ENUM_TAG_TEMPLATE,
  EnumTagSeverity,
} from './abstract-enum-tag.directive';
import { EnEventStatus } from '@shared/dto';
import { EventStatusPipe } from '@shared/pipes/event-status.pipe';

/** Read-only event/therapy status badge. See {@link AbstractEnumTag} for the tag-vs-form rule. */
@Component({
  selector: 'app-event-status-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ENUM_TAG_IMPORTS,
  template: ENUM_TAG_TEMPLATE,
  providers: [EventStatusPipe],
})
export class EventStatusTagComponent extends AbstractEnumTag<EnEventStatus> {
  private readonly pipe = inject(EventStatusPipe);

  protected translate(value: EnEventStatus): string {
    return this.pipe.transform(value) as string;
  }

  protected override severityFor(value: EnEventStatus): EnumTagSeverity {
    return EventStatusTagComponent.SEVERITY[value];
  }

  protected override iconFor(value: EnEventStatus): string | undefined {
    return EventStatusTagComponent.ICON[value];
  }

  private static readonly SEVERITY: Record<EnEventStatus, EnumTagSeverity> = {
    [EnEventStatus.SCHEDULED]: 'secondary',
    [EnEventStatus.RESCHEDULED]: 'warn',
    [EnEventStatus.INPROGRESS]: 'info',
    [EnEventStatus.COMPLETED]: 'success',
    [EnEventStatus.NOTCOMPLETED]: 'warn',
    [EnEventStatus.MISSED]: 'danger',
    [EnEventStatus.DELAYED]: 'warn',
    [EnEventStatus.SKIPPED]: 'warn',
    [EnEventStatus.DELETED]: 'contrast',
  };

  private static readonly ICON: Record<EnEventStatus, string> = {
    [EnEventStatus.SCHEDULED]: 'pi pi-calendar',
    [EnEventStatus.RESCHEDULED]: 'pi pi-calendar-clock',
    [EnEventStatus.INPROGRESS]: 'pi pi-spin pi-spinner',
    [EnEventStatus.COMPLETED]: 'pi pi-check-circle',
    [EnEventStatus.NOTCOMPLETED]: 'pi pi-times-circle',
    [EnEventStatus.MISSED]: 'pi pi-times-circle',
    [EnEventStatus.DELAYED]: 'pi pi-calendar-times',
    [EnEventStatus.SKIPPED]: 'pi pi-step-forward',
    [EnEventStatus.DELETED]: 'pi pi-trash',
  };
}
